import { BlocksIconHyperlink } from 'blocks-nextjs/blocks-web-components/components/icon/icons/hyperlink';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconHyperlink = createComponent({ react: React, tagName: 'cat-icon-hyperlink', elementClass: BlocksIconHyperlink });
